export default "__VITE_ASSET__BAc36oFX__"